var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { orderWiseProductsData } from "../../../reduxStore/actions/salesRepDataAction";
import store from "../../../reduxStore/store";
import { isLoading, salesOrderSearchText } from "../../../services/behaviorSubjectService";
import { formatIssueDateFromObject, formatDueDateFromObject, getPaymentTermsDescription } from "../../SharedFunctions";
import { buildPrintInvoicesBySalesRepUrl, handleMenuClick as sharedHandleMenuClick, handleMenuClose, handlePrintInvoiceClick, handleDuplicateOrder as sharedHandleDuplicateOrder, handlePrintFromMenu as sharedHandlePrintFromMenu, handleDuplicateOrderFromDialog, handlePrintFromDialog as sharedHandlePrintFromDialog, } from "../SalesOrderDetailsSharedBL";
export function YourSalesBL(columnVisibility) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var cv = columnVisibility;
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var _l = useState((_b = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _a === void 0 ? void 0 : _a.AllOrdersCommission) !== null && _b !== void 0 ? _b : []), paidOrders = _l[0], setPaidOrders = _l[1];
    var _m = useState(((_d = (_c = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _c === void 0 ? void 0 : _c.AllOrdersCommission) === null || _d === void 0 ? void 0 : _d.length) > 0 ? false : true), orderesLoading = _m[0], setOrdersLoading = _m[1];
    var ordersDataEffectPassRef = useRef(0);
    var selectFeatures = (_e = store.getState().salesRepData.baseData.select) !== null && _e !== void 0 ? _e : {};
    var shopCurrency = store.getState().salesRepData.loggedInRepDetails.shopCurrency;
    var currency = store.getState().salesRepData.loggedInRepDetails.currency;
    var _o = useState((_g = (_f = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _f === void 0 ? void 0 : _f.AllOrdersCommission) !== null && _g !== void 0 ? _g : []), filtered = _o[0], setFiltered = _o[1];
    var _p = useState(""), searchPaidOrderText = _p[0], setSearchPaidOrderText = _p[1];
    var _q = useState(null), selectedOrderId = _q[0], setSelectedOrderId = _q[1];
    useEffect(function () {
        var _a, _b, _c, _d;
        isLoading.next(true);
        if (((_b = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _a === void 0 ? void 0 : _a.AllOrdersCommission) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            isLoading.next(false);
        }
        if ((paidOrders === null || paidOrders === void 0 ? void 0 : paidOrders.length) === 0 && ((_d = (_c = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _c === void 0 ? void 0 : _c.AllOrdersCommission) === null || _d === void 0 ? void 0 : _d.length) === 0) {
            isLoading.next(false);
            setOrdersLoading(false);
        }
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        if ((paidOrders === null || paidOrders === void 0 ? void 0 : paidOrders.length) === 0 && ((_b = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _a === void 0 ? void 0 : _a.AllOrdersCommission) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            setPaidOrders((_c = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _c === void 0 ? void 0 : _c.AllOrdersCommission);
            setFiltered((_d = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _d === void 0 ? void 0 : _d.AllOrdersCommission);
        }
        ordersDataEffectPassRef.current += 1;
        if (ordersDataEffectPassRef.current === 2) {
            isLoading.next(false);
            setOrdersLoading(false);
        }
    }, [salesRepData.ordersData]);
    useEffect(function () {
        var filterTable = salesOrderSearchText.subscribe(function (data) {
            if ((data === null || data === void 0 ? void 0 : data.orderTab) === "Paid" && (data === null || data === void 0 ? void 0 : data.searchText) !== searchPaidOrderText) {
                setSearchPaidOrderText(data === null || data === void 0 ? void 0 : data.searchText);
                var updatedArray = __spreadArray([], filtered, true);
                var filteredOrders = updatedArray === null || updatedArray === void 0 ? void 0 : updatedArray.filter(function (order) { var _a, _b, _c, _d, _e, _f; return ((_b = (_a = order === null || order === void 0 ? void 0 : order.CustomerName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes((_c = data === null || data === void 0 ? void 0 : data.searchText) === null || _c === void 0 ? void 0 : _c.toLowerCase())) || ((_e = (_d = order === null || order === void 0 ? void 0 : order.orderNumber) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === null || _e === void 0 ? void 0 : _e.includes((_f = data === null || data === void 0 ? void 0 : data.searchText) === null || _f === void 0 ? void 0 : _f.toLowerCase())); });
                setPaidOrders(filteredOrders);
            }
        });
        return function () { return filterTable.unsubscribe(); };
    }, [paidOrders, searchPaidOrderText, setPaidOrders]);
    var HeaderSalesNames = [
        {
            label: t("yourSales_table1Column1"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderNumber) === false,
        },
        {
            label: t("yourSales_table1Column2"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderDate) === false,
        },
        {
            label: t("yourSales_PaidOrders_PaidDate"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderPaidDate) === false,
        },
        {
            label: t("yourSales_table1Column3"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.customerName) === false,
        },
        {
            label: t("salesDetailsHeader_Company"),
            hidden: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) || (cv === null || cv === void 0 ? void 0 : cv.companyName) === false,
        },
        {
            label: t("salesDetailsHeader_Location"),
            hidden: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) || (cv === null || cv === void 0 ? void 0 : cv.companyLocation) === false,
        },
        {
            label: t("yourSales_table1Column4") + "(" + shopCurrency + ")",
            inlineCSS: { textAlign: "center" },
            hidden: (cv === null || cv === void 0 ? void 0 : cv.subtotal) === false,
        },
        {
            label: t("yourSales_table1Column5") + "(" + shopCurrency + ")",
            inlineCSS: { textAlign: "center" },
            hidden: (cv === null || cv === void 0 ? void 0 : cv.commission) === false,
        },
        {
            label: t("team_column8"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.salesMethod) === false,
        },
        {
            label: t("yourSales_Action"),
            inlineCSS: { textAlign: "center" },
            hidden: false,
        },
    ];
    var ProductSalesDetailsHeaderNames = [
        {
            label: t("yourSales_column1"),
        },
        {
            label: t("yourSales_column2"),
        },
        {
            label: t("variant_title"),
        },
        {
            label: "SKU",
        },
        {
            label: t("yourSales_column3"),
        },
        {
            label: t("yourSales_column4") + "(" + shopCurrency + ")",
        },
        {
            label: t("viewProductModelColumn6") + "(" + shopCurrency + ")",
        },
        {
            label: t("yourSales_column5"),
        },
        {
            label: t("yourSales_column6"),
        },
        {
            label: t("yourSales_column7") + "(" + shopCurrency + ")",
        },
    ];
    var yorSalesArray = (_h = paidOrders === null || paidOrders === void 0 ? void 0 : paidOrders.filter(function (data) {
        var _a, _b, _c;
        return ((_a = data === null || data === void 0 ? void 0 : data.OrderStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "paid" || ((_b = data === null || data === void 0 ? void 0 : data.OrderStatus) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "partially_refunded" || ((_c = data === null || data === void 0 ? void 0 : data.OrderStatus) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === "completed";
    })) !== null && _h !== void 0 ? _h : [];
    var _r = useState(false), openProductDataDialog = _r[0], setOpenProductDataDialog = _r[1];
    /** List row when the standard order detail dialog is open (B2B flags for shared dialog). */
    var _s = useState(null), standardDialogSourceRow = _s[0], setStandardDialogSourceRow = _s[1];
    var _t = useState(), activeClientObj = _t[0], setActiveClientObj = _t[1];
    var _u = useState([]), yorSalesProductArray = _u[0], setYourSalesProductArray = _u[1];
    var _v = useState(false), openPrintInvoiceDialog = _v[0], setOpenPrintInvoiceDialog = _v[1];
    var _w = useState(null), printInvoiceData = _w[0], setPrintInvoiceData = _w[1];
    var _x = useState(null), menuAnchorEl = _x[0], setMenuAnchorEl = _x[1];
    var _y = useState(null), selectedOrder = _y[0], setSelectedOrder = _y[1];
    var _z = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _z[0], setAlertErrorMsg = _z[1];
    var shopName = (_j = store.getState().salesRepData.baseData.ShopName) !== null && _j !== void 0 ? _j : null;
    var displayPaymentTermsData = (_k = activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.paymentTerms) !== null && _k !== void 0 ? _k : null;
    // Close menu on scroll to prevent it from scrolling with the page
    useEffect(function () {
        if (!menuAnchorEl)
            return;
        var handleScroll = function () {
            setMenuAnchorEl(null);
            setSelectedOrder(null);
        };
        window.addEventListener("scroll", handleScroll, true);
        var tableContainer = document.querySelector(".selectedCompanyTable");
        if (tableContainer) {
            tableContainer.addEventListener("scroll", handleScroll);
        }
        return function () {
            window.removeEventListener("scroll", handleScroll, true);
            if (tableContainer) {
                tableContainer.removeEventListener("scroll", handleScroll);
            }
        };
    }, [menuAnchorEl]);
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    var getYourSalesProductsData = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var params, saleWiseProducts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelectedOrderId(item.OrderId);
                    setStandardDialogSourceRow(item);
                    params = {
                        order_id: item.OrderId,
                    };
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(orderWiseProductsData(params))];
                case 1:
                    saleWiseProducts = _a.sent();
                    setOpenProductDataDialog(true);
                    saleWiseProducts ? setYourSalesProductArray(saleWiseProducts.ProductDetails) : setYourSalesProductArray([]);
                    setActiveClientObj(saleWiseProducts.singleOrderDetailsFromShopify);
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var closeProductDataDialog = function () {
        setOpenProductDataDialog(false);
        setStandardDialogSourceRow(null);
    };
    var getPrintOrderDetails = function (item) { var _a; return (_a = buildPrintInvoicesBySalesRepUrl(item)) !== null && _a !== void 0 ? _a : ""; };
    var handleMenuClick = function (event, order) {
        sharedHandleMenuClick(event, order, menuAnchorEl, selectedOrder, setMenuAnchorEl, setSelectedOrder);
    };
    var handleDuplicateOrder = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sharedHandleDuplicateOrder(selectedOrder, paidOrders, dispatch, setMenuAnchorEl, setSelectedOrder)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handlePrintFromMenu = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sharedHandlePrintFromMenu(selectedOrder, setMenuAnchorEl, setSelectedOrder, setPrintInvoiceData, setOpenPrintInvoiceDialog)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDuplicatePaidOrder = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOpenProductDataDialog(false);
                    setStandardDialogSourceRow(null);
                    return [4 /*yield*/, handleDuplicateOrderFromDialog(activeClientObj, selectedOrderId || (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) || (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.order_id), false, dispatch, setAlertErrorMsg, t)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handlePrintFromDialog = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sharedHandlePrintFromDialog(activeClientObj, setPrintInvoiceData, setOpenPrintInvoiceDialog)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        HeaderSalesNames: HeaderSalesNames,
        getYourSalesProductsData: getYourSalesProductsData,
        ProductSalesDetailsHeaderNames: ProductSalesDetailsHeaderNames,
        openProductDataDialog: openProductDataDialog,
        setOpenProductDataDialog: setOpenProductDataDialog,
        closeProductDataDialog: closeProductDataDialog,
        standardDialogSourceRow: standardDialogSourceRow,
        yorSalesArray: yorSalesArray,
        activeClientObj: activeClientObj,
        yorSalesProductArray: yorSalesProductArray,
        t: t,
        getPrintOrderDetails: getPrintOrderDetails,
        shopCurrency: shopCurrency,
        shopName: shopName,
        orderesLoading: orderesLoading,
        selectFeatures: selectFeatures,
        currency: currency,
        openPrintInvoiceDialog: openPrintInvoiceDialog,
        setOpenPrintInvoiceDialog: setOpenPrintInvoiceDialog,
        printInvoiceData: printInvoiceData,
        handlePrintInvoiceClick: function (item) { return handlePrintInvoiceClick(item, setPrintInvoiceData, setOpenPrintInvoiceDialog); },
        menuAnchorEl: menuAnchorEl,
        selectedOrder: selectedOrder,
        handleMenuClick: handleMenuClick,
        handleMenuClose: function () { return handleMenuClose(setMenuAnchorEl, setSelectedOrder); },
        handleDuplicateOrder: handleDuplicateOrder,
        handlePrintFromMenu: handlePrintFromMenu,
        handleDuplicatePaidOrder: handleDuplicatePaidOrder,
        handlePrintFromDialog: handlePrintFromDialog,
        alertErrorMsg: alertErrorMsg,
        handleAlertMsgClose: handleAlertMsgClose,
        displayPaymentTermsData: displayPaymentTermsData,
        getPaymentTermsDescription: getPaymentTermsDescription,
        getIssueDate: function () { return formatIssueDateFromObject(displayPaymentTermsData); },
        getDueDate: function () { return formatDueDateFromObject(displayPaymentTermsData); },
    };
}
